import { combineReducers } from "redux";
import projectReducer from "./projectReducer";

const rootReducer = combineReducers({
  project: projectReducer,
  // Add other reducers here if you have them
});

export default rootReducer;
